import React from 'react';
import posthog from 'posthog-js';
import App from './src/containers/App';
import { onWindowLoadEvent, performDeviceIdentification, setPostHogInitialized } from './src/components/Analytics';
import { initGlobalBehaviorSignal } from './src/components/BehaviorSignalProvider';
import { installClarityProxy, initClarity } from './src/components/clarityProxy';
import { isLikelyBotOrHeadless } from './src/utils/isBot';
import { SITE_ROOT, IS_DEVELOPMENT, IS_ALPHA_STAGE, CLARITY_PROJECT_ID } from './src/api-config.mjs';
import log from 'loglevel';
import "@fontsource/sarabun/latin-400.css";


export const wrapRootElement = (props) => (
  <App {...props} browser>{props.element}</App>
);

export const onClientEntry = () => {
  log.debug("onClientEntry");

  // PostHog product analytics — proxied through first-party domain to bypass ad blockers.
  // Docs: https://posthog.com/docs/libraries/js
  // Proxy docs: https://posthog.com/docs/advanced/proxy
  if (!IS_DEVELOPMENT) {
    const posthogApiKey = IS_ALPHA_STAGE
      ? 'phc_94at20iKfqs2wcx3x9VDyqtmHADD1YvzxGnIxAE8qND'  // Alpha project
      : 'phc_WgVSA3kzH5x5U9U22VT4OhpYZgv0LjHMDtm2M95G6FD'; // Prod project
    posthog.init(posthogApiKey, {
      api_host: `${SITE_ROOT}/pd`,       // Reverse proxy via CloudFront (see cca repo backend.ts)
      ui_host: 'https://us.posthog.com',  // Required for toolbar/surveys when using a proxy
      person_profiles: 'identified_only', // Only create person profiles for identified users
    });
    setPostHogInitialized();

    // Microsoft Clarity — proxied through first-party domain to bypass ad
    // blockers. installClarityProxy() must run before initClarity() so the
    // runtime's telemetry is rewritten. Skipped entirely until a per-stage
    // CLARITY_PROJECT_ID is configured (so we don't patch globals for nothing).
    // Also skipped for bots/headless browsers — Clarity's runtime intermittently
    // throws uncaught errors during fast navigation/teardown in headless Chrome
    // (which flakes our integration tests), and bot sessions only pollute its
    // analytics. Mirrors how we already skip OpenReplay/LogRocket for bots.
    if (CLARITY_PROJECT_ID && !isLikelyBotOrHeadless()) {
      installClarityProxy();
      initClarity(CLARITY_PROJECT_ID);
    } else if (CLARITY_PROJECT_ID) {
      log.info(`Detected bot/headless browser, skipping Microsoft Clarity initialization: ${typeof navigator !== 'undefined' ? navigator.userAgent : ''}`);
    }
  }

  performDeviceIdentification();
  window.addEventListener("load", onWindowLoadEvent);

  // Initialize global behavior signal collector
  // All API requests will automatically include the behavior signal header
  initGlobalBehaviorSignal({
    enabled: true,  // Set to false to disable
    debug: false,   // Set to true for development debugging
  });
};

export const onInitialClientRender = () => {
  log.debug("ReactDOM.render has executed");
};

export const disableCorePrefetching = () => {
  log.debug("disableCorePrefetching() -> return true");
  return true;
};
